import styled from 'styled-components';

export const StyledChangeCountryWrapper = styled.div`
  display: flex;
  justify-content: flex-end; 
  padding: 0 4px;
`;

export const StyledFlag = styled.span.attrs(({ flag }: { flag: number }) => ({
  style: {
    backgroundPosition: `0 ${flag * -16}px`,
  },
}))<{ flag: number }>`
  position: relative;
  display: inline-block;
  width: 16px;
  height: 16px;
  background-image: url(https://ws1.postescanada-canadapost.ca/images/flags16x16.png);
  z-index: 1;
  box-shadow: 0 1px 2px rgb(128 128 128 / 30%);
`;

export const StyledOptionFlag = styled(StyledFlag)`
  margin-right: 8px;
`;

export const StyledButtonFlag = styled(StyledFlag)`
  top: 3px;
  margin-left: 8px;
`;

export const StyledChangeCountryButton = styled.button.attrs({ type: 'button' })`
  cursor: pointer;
  border-radius: 4px;
  background: transparent;
  border: 0;
  height: 32px;
  margin: 4px 0;
  box-sizing: border-box;
  color: ${({ theme }) => theme.colors.text};
  font-size: 14px;
  line-height: 1.29;
  padding: 3px 8px 0 8px;
  outline: 0;

  &:hover {
    box-shadow: rgba(0, 0, 0, .35) inset 0px 0 3px;
  }

  &:focus-visible, &:focus {
    box-shadow: ${({ theme }) => theme.boxShadows?.focus};
  }

  &:focus:not(&:focus-visible) {
    box-shadow: none;
  }
`;
